import { AuthenticationFormHeader } from "@/components/forms/AuthenticationFormHeader";
import { Card } from "@/components/ui/card";
import { useOnboard } from "./useOnboard";
import { Loader2 } from "lucide-react";
import { observer } from "mobx-react-lite";
import { AuthenticationFormFooter } from "@/components/forms/AuthenticationFormFooter";
import { Routes } from "@/config/routes";
import { OnboardForm } from "./OnboardForm";
import { useTranslation } from "react-i18next";

export const Onboard = observer(() => {
	const { onbaordData, isValidatingToken, isValidationTokenExpired, token } = useOnboard();

	if (isValidatingToken) {
		return <ShowLoader />;
	}

	if (isValidationTokenExpired) {
		return <ExpiredTokenContent />;
	}

	if (onbaordData) {
		return <OnboardForm token={token} onboardData={onbaordData} />;
	}

	return <UnknownError />;
});

const ShowLoader = () => (
	<div className="flex justify-center">
		<Loader2 color="white" className="animate-spin" size={48} />
	</div>
);

const ExpiredTokenContent = () => {
	const { t } = useTranslation();
	return (
		<Card>
			<AuthenticationFormHeader
				title={t("pages.onboard.expiredContent.title")}
				description={t("pages.onboard.expiredContent.description")}
			/>
			<AuthenticationFormFooter
				content={t("pages.onboard.expiredContent.footer_content")}
				link={{ linkTo: Routes.Auth.Login.path, linkText: t("pages.onboard.login_link_text") }}
			/>
		</Card>
	);
};

const UnknownError = () => {
	const { t } = useTranslation();
	return (
		<Card>
			<AuthenticationFormHeader
				title={t("pages.onboard.unknow_error.title")}
				description={t("pages.onboard.unknow_error.description")}
			/>
		</Card>
	);
};
